/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 *
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { useEffect } from 'react'

import { useCryptographyStore } from '@builddocs/cryptography-js'
import { NewUser, useCurrentUser } from '@builddocs/data-management'
import { AppNotification } from '@builddocs/exdoc-app/ui-layout'
import { Alert, AlertTitle, Typography } from '@mui/material'
import * as Sentry from '@sentry/react'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BrowserRouter as Router } from 'react-router-dom'
import { toast } from 'react-toastify'

import { tracerError } from '../providers/ApptracerProvider'

import RootScreen from './RootScreen'

import 'react-toastify/dist/ReactToastify.css'

toast.configure()

const isDevEnvironment =
  process.env.NODE_ENV === 'development' || process.env.NX_ENV === 'development'

const App = () => {
  const { init } = useCryptographyStore()

  const { user } = useCurrentUser<NewUser>()

  useEffect(() => {
    init()
  }, [init])

  return (
    <>
      {isDevEnvironment ? (
        <Typography
          color="error.main"
          mb={1}
          sx={{ position: 'fixed', top: 0, left: 4, zIndex: 10000 }}
          variant="subtitle1"
        >
          DEV режим
        </Typography>
      ) : null}
      <Router>
        <Sentry.ErrorBoundary
          beforeCapture={scope => {
            scope.setTag('location', 'Root')
          }}
          fallback={({ error }) => {
            tracerError.error(error, {
              userId: user?.userId,
              severity: 'fatal',
              issueKey: 'boundary/root-layout',
            })
            return (
              <Alert severity="error">
                <AlertTitle>Произошла какая-то ошибка</AlertTitle>
                {error.toString}
              </Alert>
            )
          }}
        >
          <AppNotification />
          {/*<AllertComponent/>*/}
          <RootScreen />
          <ReactQueryDevtools initialIsOpen={false} position="bottom-left" />
        </Sentry.ErrorBoundary>
      </Router>
    </>
  )
}

export default Sentry.withProfiler(App, { name: 'Executive documentation' })
